<template>
  <div class="c-code-input">
    <div v-for="(value, index) in values" :key="index">
      <label class="c-registration__label--sr-only" :for="index.toString()"
        >Code Input Field {{ index }}</label
      >
      <input
        class="c-code-input__field"
        type="text"
        inputmode="numeric"
        autocomplete="one-time-code"
        :data-id="index"
        :id="index.toString()"
        v-model="values[index]"
        @keydown="onKeyDown"
        @paste="onPaste"
        :autofocus="index === 0"
        data-cy="codeInput"
        :maxlength="length"
        pattern="\d{1}"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  (e: 'complete', code: string): void
}>()

const length = ref(6)
const values = ref(Array(length.value))

watch(
  values,
  (newValues) => {
    if (newValues[0] && newValues[0].length === length.value) {
      const pasteArray = [...newValues[0]]
      pasteArray.length = length.value
      values.value = pasteArray
    }
    if (!newValues.includes(undefined) && newValues.length === length.value) {
      emit('complete', newValues.join(''))
    }
  },
  { deep: true }
)

onMounted(() => {
  if (process.client && 'OTPCredential' in window) {
    navigator.credentials
      .get({
        otp: { transport: ['sms'] },
      })
      .then((otp) => {
        if (otp) {
          const pasteArray = [...otp.code]
          pasteArray.length = length.value
          values.value = pasteArray
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }
})

function onKeyDown(event: any) {
  if (event.ctrlKey || event.metaKey) {
    return false
  }

  event.preventDefault()

  const index = parseInt(event.target.dataset.id)
  const prevIndex = index - 1
  const nextIndex = index + 1
  let prev: HTMLElement | null
  let next: HTMLElement | null

  switch (event.key) {
    case 'Backspace': {
      values.value[index] = undefined
      prev = document.querySelector(`[data-id="${prevIndex}"]`)
      if (prev) prev.focus()
      break
    }
    case 'ArrowLeft':
      prev = document.querySelector(`[data-id="${prevIndex}"]`)
      if (prev) prev.focus()
      break
    case 'ArrowRight':
      next = document.querySelector(`[data-id="${nextIndex}"]`)
      if (next) next.focus()
      break
    default:
      if (/\d/.test(event.key)) {
        values.value[index] = event.key
        next = document.querySelector(`[data-id="${nextIndex}"]`)
        if (next) next.focus()
      }
      break
  }
}

function onPaste(event: any) {
  event.preventDefault()
  const pasteText = event.clipboardData.getData('text/plain')
  if (/^\d+$/.test(pasteText)) {
    const pasteArray = [...pasteText]
    pasteArray.length = length.value
    values.value = pasteArray
  }
}
</script>
